import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Friend, FriendBase } from "../slices/userSlice";
import { useApiRequest } from "./useApiRequest";
import { KeyedMutator } from "swr";

type FriendModifiable = FriendBase;

export default function useFriendRequest({
  userData,
  setFriendRequestLoading,
  mutate,
}: {
  userData: Friend;
  setFriendRequestLoading: React.Dispatch<React.SetStateAction<boolean>>;
  mutate: KeyedMutator<Friend>;
}) {
  const [modifiableData, setModifiableData] =
    useState<FriendModifiable>(userData);

  useEffect(() => {
    setModifiableData(userData);
  }, [userData]);

  const apiRequest = useApiRequest();

  const sendFriendRequest = async () => {
    setFriendRequestLoading(true);
    const response = await apiRequest.post<{
      success: boolean;
      accepted: boolean;
    }>("/users/friend-request", {
      userId: userData.userId,
    });
    setFriendRequestLoading(false);
    if (!response) {
      toast.error(
        "Nastala chyba. Nepodařilo se odeslat žádost o přátelství. Zkontroluj připojení k internetu."
      );
      return;
    }

    if (response.accepted) {
      setModifiableData((prev) => ({ ...prev, isFriend: true }));
      mutate();
    }

    setModifiableData((prev) => ({ ...prev, friendRequestSent: true }));
  };

  const removeFriend = async () => {
    setFriendRequestLoading(true);
    const response = await apiRequest.post(`/users/friend/remove`, {
      userId: userData.userId,
    });
    setFriendRequestLoading(false);
    if (!response) {
      toast.error("Nastala chyba. Zkontroluj připojení k internetu.");
      return;
    }

    setModifiableData((prev) => ({
      ...prev,
      isFriend: false,
      friendRequestSent: false,
      friendRequestReceived: false,
    }));
  };

  return { friendData: modifiableData, sendFriendRequest, removeFriend };
}
